export default function NotListPrivateBetaPage() {
  return (
    <div className="flex h-full w-full flex-col items-start gap-4 bg-default-background px-6 py-12">
      <div className="container max-w-none flex h-full w-full flex-col items-center justify-center gap-4 bg-default-background py-12">
        <div className="flex w-112 flex-col items-center justify-center gap-4 px-1 py-1">
          <span className="w-full text-section-header font-section-header text-default-font">
            Thank you for signing up!
          </span>
          <span className="w-full text-label font-label text-default-font">
            We’re excited to have you on board. A member of our team will reach
            out to learn more about your use case and assist with providing
            access to the product.
          </span>
          <span className="w-full text-label font-label text-default-font">
            We look forward to connecting with you.
          </span>
          <span className="w-full text-body font-body text-default-font">
            The Chkk Team
          </span>
        </div>
      </div>
    </div>
  );
}
